export default {
    methods: {
        createDateRangeArray(startDate, stopDate) {
            const dateArray = [];
            let currentDate = moment(startDate).utcOffset(startDate);
            const endDate = moment(stopDate).utcOffset(stopDate);
            while (currentDate <= endDate) {
                dateArray.push(moment(currentDate).format('MM/YYYY'));
                currentDate = moment(currentDate).add(1, 'months');
            }

            return dateArray;
        },

        parseData(options) {
            let results = null;
            options = Object.assign({
                data: null,
                dateField: 'created_date',
                startDate: null,
                stopDate: null,
                isStacked: true
            }, options);
            let datesArray = this.createDateRangeArray(options.startDate, options.stopDate);

            results = this.parseStacked(options, datesArray);

            return results;
        },

        parseStacked(options, datesArray) {
            let results = [];

            for (var type in options.data) {
                let typeArr = this.buildBarChartGroup(options, datesArray, type);
                results.push(typeArr);
            }

            return results;
        },

        buildBarChartGroup(options, datesArray, type) {
            let typeArr = {
                key: type,
                values: []
            };

            datesArray.forEach((date) => {
                let baseObj = this.createBaseObj(date);

                options.data[type].forEach((typeDate) => {
                    if (date === typeDate[options.dateField]) {
                        typeDate.loan_amount_sum = parseInt(typeDate.loan_amount_sum);
                        baseObj = typeDate;
                    }
                });

                typeArr.values.push(baseObj);
            });

            return typeArr;
        },

        createBaseObj(date) {
            return {
                created_date: date,
                funded_date: date,
                loan_amount_average: 0,
                loan_amount_sum: 0,
                loan_count: 0
            }
        },
    }
}